import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiStar } from "react-icons/fi";
import axios from "axios";

import { test_ip } from "../services/constants";
import { toast } from "react-toastify";
import { setError } from "../services/actions";
import { useDispatch } from "react-redux";

const ProviderRating = () => {
  const loc = useLocation();
  const nav = useNavigate();
  const [currentValue, setCurrentValue] = useState(0);
  const [hoverValue, setHoverValue] = useState(undefined);
  const stars = Array(5).fill(0);
  const review = useRef();
  const diapach = useDispatch();

  const handleClick = (value) => {
    setCurrentValue(value);
    console.log(value);
  };

  const handleMouseOver = (newHoverValue) => {
    setHoverValue(newHoverValue);
  };

  const handleMouseLeave = () => {
    setHoverValue(undefined);
  };

  const handleReview = () => {
    var user = JSON.parse(localStorage.getItem("user"));
    var data = {
      user_id: user.user_id,
      server_token: user.server_token,
      order_id: loc.state.item.order_list.order_payment_detail.order_id,
      user_review_to_provider: review.current.value,
      user_rating_to_provider: currentValue,
    };
    Rating_To_Provider(data);
  };

  useEffect(() => {
    console.log(loc.state.item);
  }, []);

  const Rating_To_Provider = function (data) {
    // Rate Deliverymans after completing an order or order history page
    var body = data;
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/rating_to_provider`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            // you would get something here
            alert("Thank you");
            nav("/order");
          } else {
            console.log(res.data.error_code);
            if (res.data.error_code == 999) {
              console.log(true);
              toast.error("Please Login !", {
                position: toast.POSITION.TOP_RIGHT,
              });
              localStorage.clear();
              window.location.reload();
              console.log("sdfgh");
            } else {
              diapach(
                setError({
                  error: true,
                  message: `failed, please check again(${res.data.error_code})`,
                })
              );
            }
          }
        } else {
          console.log("erororor", res.data.error_code);
          if (res.data.error_code == 999) {
            console.log(true);
            toast.error("Please Login !", {
              position: toast.POSITION.TOP_RIGHT,
            });
            localStorage.clear();
            window.location.reload();
            console.log("sdfgh");
          } else {
            diapach(
              setError({
                error: true,
                message: `failed, please check again(${res.data.error_code})`,
              })
            );
          }
        }
      })
      .catch((err) => {
        // do something
        diapach(setError({ error: true, message: "failed,please reload" }));
      });
  };

  return (
    <div className="a-store-rating-page">
      <div className="a-whole-main-container">
        <div className="a-whole-container">
          <div className="a-img-container">
            <img
              src="zmall-logo.png"
              alt="zmall-logo"
              style={{
                width: "70px",
                borderRadius: "50%",
              }}
            />
            <p>
              {loc.state.item && loc.state.item.provider_detail.first_name}{" "}
              {loc.state.item && loc.state.item.provider_detail.last_name}
            </p>
            <div>
              {stars.map((_, index) => {
                return (
                  <FiStar
                    key={index}
                    size={24}
                    onClick={() => handleClick(index + 1)}
                    onMouseOver={() => handleMouseOver(index + 1)}
                    onMouseLeave={handleMouseLeave}
                    color={(hoverValue || currentValue) > index ? "orange" : ""}
                    style={{
                      marginRight: 10,
                      cursor: "pointer",
                    }}
                  />
                );
              })}
            </div>
            <textarea
              cols="30"
              rows="10"
              placeholder="Enter your review here"
              ref={review}
            ></textarea>
          </div>
          <button
            disabled={currentValue < 1 ? true : false}
            onClick={handleReview}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProviderRating;
